var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_defineProperty.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_defineProperty.js
// module chunks = 1